import React from 'react';
import { SecretKeyField } from '@repo/ui/SecretKeyField';

export interface ApiKeyProps {
  id: string;
  token: string;
}

const ApiKey = ({ id, token }: ApiKeyProps) => {
  return <SecretKeyField id={id} keyString={token} />;
};

export default ApiKey;
